import { debounce } from "../utils/helpers";
export class FormValidator {
    constructor(formSelector) {
        this.inputs = {};
        this.submitBtn = null;
        this.validateRules = {
            'js-validate-phone': /^[0-9+]{6,13}$/,
            'js-validate-phone-mask': /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
            'js-validate-name': /^[a-zA-Z\u0400-\u04FF]{2,30}$/,
            'js-validate-fullname': /^(?=.{2,60}$)[a-zA-Z\u0400-\u04FF]+(?:['-][a-zA-Z\u0400-\u04FF]+)*(?: +[a-zA-Z\u0400-\u04FF]+(?:['-][a-zA-Z\u0400-\u04FF]+)*)*$/,
            'js-validate-email': /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
            'js-validate-min-sum-500': /^(?:[5-9]\d{2}|[1-9]\d{3,})$/
        };
        const foundForm = document.querySelector(formSelector);
        if (!foundForm) {
            return;
        }
        this.form = foundForm;
        this.collectElements();
        this.initMask();
        this.attachEvents();
        this.initialValidate();
        this.initForm();
    }
    collectElements() {
        const elements = this.form.querySelectorAll('input');
        const submitbutton = this.form.querySelector('[type="submit"]');
        if (submitbutton) {
            this.submitBtn = submitbutton;
        }
        elements.forEach(el => {
            if (!el.name)
                return;
            const isRequired = el.hasAttribute('required');
            this.inputs[el.name] = {
                name: el.name,
                isValid: isRequired ? false : true,
                required: isRequired,
                element: el
            };
        });
    }
    initMask() {
        const formatPhone = (value) => {
            let digits = value.replace(/\D/g, '');
            if (!digits.length)
                return '';
            if (digits.length === 10)
                digits = '7' + digits;
            if (digits[0] === '8')
                digits = '7' + digits.slice(1);
            if (digits[0] !== '7')
                digits = '7' + digits;
            const d = digits.slice(1, 11);
            let result = '+7';
            if (d.length > 0)
                result += ' (' + d.slice(0, 3);
            if (d.length > 3)
                result += ') ' + d.slice(3, 6);
            if (d.length > 6)
                result += '-' + d.slice(6, 8);
            if (d.length > 8)
                result += '-' + d.slice(8, 10);
            return result;
        };
        Object.values(this.inputs).forEach(input => {
            const el = input.element;
            if (!el.classList.contains('js-validate-phone-mask'))
                return;
            el.placeholder = '+7 (___) ___-__-__';
            if (el.value)
                el.value = formatPhone(el.value);
            el.addEventListener('input', () => {
                var _a;
                const caret = (_a = el.selectionStart) !== null && _a !== void 0 ? _a : el.value.length;
                const caretAtEnd = caret === el.value.length;
                const digitsBeforeCaret = el.value.slice(0, caret).replace(/\D/g, '').length;
                el.value = formatPhone(el.value);
                if (caretAtEnd)
                    return;
                let pos = 0;
                let count = 0;
                while (pos < el.value.length && count < digitsBeforeCaret) {
                    if (/\d/.test(el.value[pos]))
                        count++;
                    pos++;
                }
                el.setSelectionRange(pos, pos);
            });
        });
    }
    attachEvents() {
        const debouncedValidate = debounce((input) => {
            this.validateInput(input);
            this.updateSubmitState();
        }, 1000);
        Object.values(this.inputs).forEach(input => {
            input.element.addEventListener('input', () => {
                debouncedValidate(input);
            });
            input.element.addEventListener('blur', () => {
                this.validateInput(input);
                this.updateSubmitState();
            });
        });
    }
    initialValidate() {
        Object.values(this.inputs).forEach(input => {
            this.validateInput(input, false);
        });
        this.updateSubmitState();
    }
    updateSubmitState() {
        if (!this.submitBtn)
            return;
        this.submitBtn.disabled = !this.validateAll();
    }
    validateInput(input, markUI = true) {
        const value = input.element.value.trim();
        if (input.required) {
            if (value.length === 0) {
                input.isValid = false;
                if (markUI)
                    this.markInvalid(input);
                return;
            }
        }
        let patternMatched = true;
        let hasPattern = false;
        for (const ruleClass in this.validateRules) {
            if (input.element.classList.contains(ruleClass)) {
                hasPattern = true;
                const regex = this.validateRules[ruleClass];
                patternMatched = regex.test(value);
                break;
            }
        }
        if (!input.required && value === '' && hasPattern) {
            input.isValid = true;
        }
        else if (hasPattern) {
            input.isValid = patternMatched;
        }
        else {
            input.isValid = true;
        }
        if (markUI) {
            if (!input.isValid) {
                this.markInvalid(input);
            }
            else {
                this.markValid(input);
            }
        }
    }
    validateAll() {
        Object.values(this.inputs).forEach(i => this.validateInput(i, false));
        return Object.values(this.inputs).every(input => input.isValid);
    }
    markInvalid(input) {
        input.element.classList.add('not-valid');
    }
    markValid(input) {
        input.element.classList.remove('not-valid');
    }
    initForm() {
        this.form.addEventListener('submit', (e) => {
            if (!this.validateAll()) {
                e.preventDefault();
                console.warn('Form validation failed');
                Object.values(this.inputs).forEach(i => {
                    if (!i.isValid)
                        this.markInvalid(i);
                });
                this.updateSubmitState();
                return;
            }
            console.log('Form is valid!');
        });
    }
}
